/* import __COLOCATED_TEMPLATE__ from './linking-success.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { wait } from '@banking/ui/utils/wait';
import { inject as service } from '@ember/service';
import { listInvestmentAccountsRequestAction } from '@banking/ui/workflows/investments';
import { Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
const DISPLAY_TIME_FOR_SUCCESS = 1500;
let Linking = (_class = class Linking extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "investmentsWorkflow", _descriptor, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor2, this);
    _initializerDefineProperty(this, "cashAppPayKitSdk", _descriptor3, this);
    this.init();
  }
  async init() {
    await wait(DISPLAY_TIME_FOR_SUCCESS);
    this.cashAppPayKitSdk.restart();

    // fetch the newly created account
    const merchantOwner = Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    });
    this.investmentsWorkflow.emit(listInvestmentAccountsRequestAction(merchantOwner));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "investmentsWorkflow", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cashAppPayKitSdk", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Linking as default };